/**
 * EmptyState - consistent "nothing here yet" block.
 *
 * Props:
 *   icon        (node, optional) - an MUI icon element
 *   title       (node, required)
 *   description (node, optional)
 *   action      (node, optional) - e.g. a CTA button
 *   minHeight   (number|string, default '40vh')
 *   sx          (object, optional)
 */

import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const EmptyState = ({ icon, title, description, action, minHeight = '40vh', sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      minHeight,
      px: 2,
      ...sx,
    }}
  >
    {icon && (
      <Box sx={{ color: 'text.secondary', mb: 2, '& > svg': { fontSize: 56 } }}>{icon}</Box>
    )}
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 420 }}>
        {description}
      </Typography>
    )}
    {action && <Stack sx={{ mt: 3 }}>{action}</Stack>}
  </Box>
);

export default EmptyState;
